import { Input } from "../../shadcn";
import { cn } from "../../../lib/utils";
import { ComponentProps } from "react";

/** @deprecated Use AppSearchInput instead */
export const SearchInput = (props: ComponentProps<"input">) => {
  return <Input isSearch {...props} className={cn(props.className, "pl-8")} />;
};
